import currentAcademicInstitution from './academicInstitutions.js.erb';
import { isGdprCountry, isCautiousCountry } from './countries.js.erb';
import isWholesiesConsentUpdateEnabled from './isWholesiesConsentUpdateEnabled';
import isExplicitConsentEnabled from './isExplicitConsentEnabled';
import updateConsentCopy from './updateConsentCopy';

export {
  currentAcademicInstitution,
  isGdprCountry,
  isCautiousCountry,
  isWholesiesConsentUpdateEnabled,
  isExplicitConsentEnabled,
  updateConsentCopy,
};
